import PropTypes from 'prop-types';
import Image from 'ui/Image';
import {FieldTypes} from 'utils/page';
import WithPage from '../WithPage';

const {TIP_TYPE, TITLE, BODY} = FieldTypes;

const Tip = ({data}) => {
    const textFields = data.getTextFieldsMap();
    const img = textFields.has(TIP_TYPE)
        ? textFields.get(TIP_TYPE).getTextValue().toLowerCase()
        : null;
    const title = textFields.has(TITLE)
        ? textFields.get(TITLE).getTextValue()
        : null;
    const body = textFields.has(BODY)
        ? textFields.get(BODY).getTextValue()
        : null;

    return (
        <div className="Tip">
            <div className="Tip-content">
                {img && <Image src={`../img/tip-${img}.png`} alt={title} />}
                {title && <h1 className="heading-md">{title}</h1>}
                {body && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: body,
                        }}
                    />
                )}
            </div>
        </div>
    );
};

Tip.propTypes = {
    data: PropTypes.object.isRequired,
};

export default WithPage(Tip);
